function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFdImgCookie96(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 164 164",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.32,0,0,0.32,-3618.64,-3216.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,10089.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.966,344.973C458.158,407.656 409.027,456.776 346.355,466.595C274.267,477.888 202.179,477.888 130.081,466.595C67.408,456.777 18.288,407.656 8.47,344.973C-2.823,272.885 -2.823,200.797 8.47,128.709C18.288,66.037 67.409,16.906 130.081,7.098C177.026,-0.255 223.971,-2.823 270.916,-0.596C263.13,9.191 258.561,21.515 258.561,34.644C258.561,37.14 258.726,39.656 259.066,42.193C260.799,55.218 266.821,66.635 275.526,75.184C284.23,83.723 295.616,89.416 308.064,91.004C300.185,101.152 296.183,113.445 296.183,125.78C296.183,139.208 300.927,152.687 310.559,163.505C321.769,176.077 337.311,182.481 352.925,182.481C363.145,182.481 373.386,179.738 382.472,174.179C382.781,187.637 387.866,200.219 396.322,209.986C404.779,219.752 416.608,226.703 430.365,228.869C433.356,229.343 436.326,229.57 439.255,229.57C453.085,229.57 466.069,224.496 476.114,215.885C477.423,258.911 474.711,301.947 467.966,344.973Z",
    style: {
      fill: "rgb(198,134,92)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,10088.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.41,467.524C66.016,456.747 18.143,408.131 8.47,346.346C-2.823,274.258 -2.823,202.17 8.47,130.082C18.143,68.307 66.016,19.681 127.41,8.914C94.45,34.325 71.369,71.823 64.614,114.952C51.733,197.126 51.733,279.3 64.614,361.474C71.369,404.615 94.449,442.113 127.41,467.524Z",
    style: {
      fill: "rgb(177,110,61)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,9670.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.631,469.654L424.916,467.939C418.866,461.889 418.534,452.188 424.156,445.739L441.447,425.901C447.641,418.795 458.557,418.421 465.222,425.087L469.484,429.349C476.149,436.014 475.775,446.93 468.67,453.124L448.832,470.415C442.381,476.035 432.68,475.703 426.631,469.654Z",
    style: {
      fill: "rgb(255,224,125)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,9599.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.346,511.552L367.003,510.924C358.739,508.71 353.601,500.475 355.244,492.079L360.3,466.253C362.111,457.002 371.378,451.221 380.482,453.66L386.304,455.22C395.409,457.66 400.543,467.3 397.486,476.217L388.951,501.111C386.177,509.204 377.61,513.767 369.346,511.552Z",
    style: {
      fill: "rgb(255,224,125)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,9810.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.176,387.028L453.548,384.685C451.334,376.421 455.896,367.854 463.989,365.079L488.883,356.544C497.8,353.487 507.44,358.621 509.88,367.726L511.44,373.548C513.88,382.653 508.098,391.92 498.847,393.73L473.021,398.786C464.626,400.431 456.391,395.292 454.176,387.028Z",
    style: {
      fill: "rgb(255,224,125)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,11729.4,10381.1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.768,
    cy: 302.333,
    rx: 46.051,
    ry: 46.051,
    style: {
      fill: "rgb(102,69,69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,9960.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.892,347.02C126.334,347.907 122.601,348.381 118.764,348.381C93.332,348.381 72.716,327.755 72.716,302.323C72.716,276.891 93.332,256.275 118.764,256.275C122.6,256.275 126.334,256.749 129.892,257.636C109.833,262.607 94.972,280.727 94.972,302.322C94.972,323.918 109.833,342.049 129.892,347.02Z",
    style: {
      fill: "rgb(82,56,56)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,11600.8,10506.9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.367,
    cy: 175.18,
    rx: 24.042,
    ry: 24.042,
    style: {
      fill: "rgb(102,69,69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,10214.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.82,198.035C122.469,198.808 119.963,199.221 117.364,199.221C104.081,199.221 93.324,188.464 93.324,175.181C93.324,161.898 104.08,151.141 117.364,151.141C119.963,151.141 122.469,151.554 124.82,152.327C115.188,155.452 108.226,164.496 108.226,175.181C108.227,185.866 115.188,194.91 124.82,198.035Z",
    style: {
      fill: "rgb(82,56,56)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,11630,10704.9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.978,
    cy: 90.799,
    rx: 16.804,
    ry: 16.804,
    style: {
      fill: "rgb(102,69,69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,10383.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.811,106.557C234.996,107.227 233.036,107.599 230.984,107.599C221.702,107.599 214.174,100.07 214.174,90.789C214.174,81.518 221.702,73.989 230.984,73.989C233.036,73.989 234.996,74.36 236.811,75.031C230.396,77.393 225.828,83.56 225.828,90.789C225.828,98.028 230.397,104.195 236.811,106.557Z",
    style: {
      fill: "rgb(82,56,56)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,11836.7,10531.8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.782,
    cy: 280.673,
    rx: 16.804,
    ry: 16.804,
    style: {
      fill: "rgb(102,69,69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,10003.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.615,296.43C251.8,297.1 249.84,297.472 247.788,297.472C238.506,297.472 230.978,289.944 230.978,280.662C230.978,271.391 238.506,263.862 247.788,263.862C249.84,263.862 251.8,264.233 253.615,264.904C247.2,267.266 242.632,273.433 242.632,280.662C242.632,287.901 247.2,294.068 253.615,296.43Z",
    style: {
      fill: "rgb(82,56,56)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,11831,10748.7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 353.339,
    cy: 169.365,
    r: 29.858,
    style: {
      fill: "rgb(102,69,69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,10226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.732,198.013C359.071,198.797 356.256,199.22 353.337,199.22C336.846,199.22 323.481,185.854 323.481,169.364C323.481,152.874 336.847,139.508 353.337,139.508C356.256,139.508 359.071,139.931 361.732,140.715C349.336,144.335 340.281,155.793 340.281,169.365C340.281,182.935 349.335,194.393 361.732,198.013Z",
    style: {
      fill: "rgb(82,56,56)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,9833.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.858,364.448L351.786,349.905C355.231,346.03 361.547,347.123 363.49,351.929L372.262,373.629C374.493,379.147 369.245,384.751 363.593,382.886L341.893,375.729C337.118,374.154 335.518,368.205 338.858,364.448Z",
    style: {
      fill: "rgb(198,134,92)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11308.3,9937.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.622,292.313L447.164,302.622C452.637,305.369 453.32,312.909 448.429,316.595L426.348,333.233C420.733,337.464 412.736,333.188 413.137,326.168L414.676,299.221C415.015,293.292 421.314,289.649 426.622,292.313Z",
    style: {
      fill: "rgb(198,134,92)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdImgCookie96);
export default __webpack_public_path__ + "static/media/fd_img_cookie96.68f5477f.svg";
export { ForwardRef as ReactComponent };